export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">How the Matching Process Works</h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Our proven process ensures your book reaches the right readers at the right time
          </p>
        </div>
        
        <div className="grid md:grid-cols-4 gap-8">
          <div className="relative">
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mb-6 mx-auto">
                <span className="text-3xl font-bold text-white">1</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Submit Your Book</h3>
              <p className="text-gray-700 text-center leading-relaxed">
                Authors submit their book details through our request form. We review Amazon and Goodreads descriptions to understand your story.
              </p>
            </div>
            <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
              <i className="ri-arrow-right-line text-4xl text-amber-400"></i>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mb-6 mx-auto">
                <span className="text-3xl font-bold text-white">2</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Expert Evaluation</h3>
              <p className="text-gray-700 text-center leading-relaxed">
                We carefully evaluate your book using Readnrate and other platforms to understand reader interests and match potential.
              </p>
            </div>
            <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
              <i className="ri-arrow-right-line text-4xl text-amber-400"></i>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mb-6 mx-auto">
                <span className="text-3xl font-bold text-white">3</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Strategic Matching</h3>
              <p className="text-gray-700 text-center leading-relaxed">
                We match your book with the most suitable book clubs from our network of 300+ active communities, both online and in-person.
              </p>
            </div>
            <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
              <i className="ri-arrow-right-line text-4xl text-amber-400"></i>
            </div>
          </div>
          
          <div>
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mb-6 mx-auto">
                <span className="text-3xl font-bold text-white">4</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Campaign Launch</h3>
              <p className="text-gray-700 text-center leading-relaxed">
                Your book is professionally positioned and promoted to engaged readers who are genuinely interested in discussing it.
              </p>
            </div>
          </div>
        </div>
        
        <div className="mt-16 bg-gradient-to-r from-amber-500 to-amber-600 rounded-2xl p-12 text-center shadow-xl">
          <h3 className="text-3xl font-bold text-white mb-4">Limited Campaign Slots Available</h3>
          <p className="text-xl text-amber-50 mb-8 max-w-2xl mx-auto">
            We maintain quality by accepting only standout books that truly resonate with our book club communities.
          </p>
          <a 
            href="#request-slot" 
            className="whitespace-nowrap inline-block px-10 py-4 bg-white text-amber-600 text-lg font-semibold rounded-lg hover:bg-amber-50 transition-all duration-300 shadow-lg cursor-pointer"
          >
            Check Availability
          </a>
        </div>
      </div>
    </section>
  );
}
